import angular from 'angular';
import vetFormComponent from './vet-form.component';

export default angular.module('components.app.adverseEvent.vetForm', [])
  .component('vetForm', vetFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/vet-form/vet-form.module.js